import { Dispatch, SetStateAction, useEffect, useRef, useState} from 'react';
import { GROUPS, getGroupFromRoles } from '../../constants/authGroups';
import { NavigateFunction } from 'react-router-dom';
import { useAuthProvider } from '../../providers/AuthProvider';
import { useHistoryProvider } from '../../providers/HistoryProvider';
import CompensationHistoryIFS from '../../components/CompensationHistoryIFS/CompensationHistoryIFS';
import CompensationHistoryNonIFS from '../../components/CompensationHistoryNonIFS/CompensationHistoryNonIFS';
interface Props {
    navigate: NavigateFunction;
    setActiveMenuIndex: Dispatch<SetStateAction<number>>;
}

const History = ({navigate, setActiveMenuIndex}: Props) => {
    const authContext = useAuthProvider();
    const historyContext = useHistoryProvider();
    const hasFetchedHistory = useRef(false);
    const [inFlightUser, setInFlightUser] = useState<boolean>(false);

    useEffect(() => {
        if (
            !hasFetchedHistory.current
            && authContext.user.roles.length
            && getGroupFromRoles(authContext.user.roles) === GROUPS.inFlight.name
        ) {
            setInFlightUser(true);
            historyContext.getIFSHistory();
            hasFetchedHistory.current = true;
        }
    }, [authContext.user.roles, historyContext]);

    useEffect(() => {
        setActiveMenuIndex(1);
    }, [setActiveMenuIndex]);

    return (
        <div className="c-page" id="c-page">
            {inFlightUser ? (
                <CompensationHistoryIFS navigate={navigate}/>
            ) : (
                <CompensationHistoryNonIFS navigate={navigate} />
            )}
        </div>
    );  
};

export default History;

